// Service worker registration for BookARoom (hand-written, no Workbox / CRA PWA template).
//
// This registers /service-worker.js ONLY in a context where it is safe:
//   - the browser supports service workers,
//   - we are in a production build,
//   - we are NOT running inside the Capacitor native WebView,
//   - and we are in a secure context (https) or on localhost.
//
// Any failure during registration is swallowed so it can never break app boot.

// True when the app is running inside the Capacitor native WebView.
// We check several signals because window.Capacitor may not be populated yet
// (or isNativePlatform may be unavailable) depending on plugin load order.
function isCapacitorEnvironment() {
  try {
    if (typeof window === 'undefined') {
      return false;
    }
    if (window.Capacitor) {
      // Newer Capacitor exposes isNativePlatform().
      if (typeof window.Capacitor.isNativePlatform === 'function') {
        if (window.Capacitor.isNativePlatform()) {
          return true;
        }
      } else {
        // Older shape: presence of Capacitor on a non-web platform.
        return true;
      }
    }
    var protocol = window.location.protocol;
    if (protocol === 'capacitor:' || protocol === 'ionic:') {
      return true;
    }
  } catch (e) {
    // If anything throws, err on the side of NOT registering.
    return true;
  }
  return false;
}

// True when we are allowed to use a service worker (secure context or localhost).
function isSecureEnough() {
  if (typeof window === 'undefined') {
    return false;
  }
  if (window.isSecureContext) {
    return true;
  }
  var hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '[::1]' ||
    // 127.0.0.0/8
    /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/.test(hostname)
  );
}

export function register() {
  // Only in production builds.
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  // Never register inside the Capacitor native WebView.
  if (isCapacitorEnvironment()) {
    return;
  }

  // Only over https or on localhost.
  if (!isSecureEnough()) {
    return;
  }

  // The SW lives at the site root next to index.html.
  var publicUrl = process.env.PUBLIC_URL || '';
  var swUrl = publicUrl + '/service-worker.js';

  window.addEventListener('load', function () {
    try {
      navigator.serviceWorker
        .register(swUrl)
        .catch(function () {
          // Swallow registration errors — must never break the app.
        });
    } catch (e) {
      // Swallow synchronous errors too.
    }
  });
}

export function unregister() {
  try {
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then(function (registration) {
          registration.unregister();
        })
        .catch(function () {
          // Ignore.
        });
    }
  } catch (e) {
    // Ignore.
  }
}
